import { render } from "./CalibrationIcon.vue?vue&type=template&id=33abaa5c"
import script from "./CalibrationIcon.vue?vue&type=script&lang=js"
export * from "./CalibrationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__